import { ArrowBack } from '@mui/icons-material'
import { Avatar, Box } from '@mui/material'
import { IOrganizationUserDTO } from 'data/dtos/authentication/i-organization-user-dto'
import { formatCNPJ } from 'utils/is-valid-cnpj'
import { stringToAvatar } from 'utils/string-to-avatar'
import TableStatus from '../table-status'
import { useStyles } from './styles'

interface IAuthenticationsHeaderInfoProps {
  handleReturn: () => void
  organization: IOrganizationUserDTO
}

const AuthenticationsHeaderInfo: React.FC<IAuthenticationsHeaderInfoProps> = ({ handleReturn, organization }) => {
  const classes = useStyles()

  return (
    <Box className={classes.headerContainer}>
      <Box className={classes.headerBack}>
        <ArrowBack
          fontSize='small'
          color='primary'
          onClick={handleReturn}
          sx={{ cursor: 'pointer' }}
        />
        <h1>Cofre Digital</h1>
      </Box>

      <Box className={classes.containnerBase}>
        <section>
          <span className={classes.title}>Cliente</span>
          <div className={classes.containerInfo}>
            <Avatar {...stringToAvatar(organization.corporateName!, '#BDBDBD')} />

            <Box className={classes.groupText}>
              <span style={{ fontWeight: 600 }}>{organization.corporateName}</span>
              <span className={classes.subTitle}>{formatCNPJ(organization.federalTaxId, false)}</span>
            </Box>

            <TableStatus status='authorized' />
          </div>
        </section>

        <section>
          <span className={classes.title}>Conector</span>
          <div></div>
        </section>
      </Box>
    </Box>
  )
}

export default AuthenticationsHeaderInfo
